import script from "./Metadata.vue?vue&type=script&setup=true&lang=js"
export * from "./Metadata.vue?vue&type=script&setup=true&lang=js"

import "./Metadata.vue?vue&type=style&index=0&id=5dd44a57&lang=scss&scoped=true"
script.__scopeId = "data-v-5dd44a57"

export default script